import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

const EffortReviewNav = (props) => {
  console.log("effortReviewNav", props);
  return (
    <div className="EffortReviewNav center" data-testid="EffortReviewNav">
      <Link
        to={`${process.env.PUBLIC_URL}/vtr-catch`}
        state={{
          trip_id: props.trip_id,
          client_id: props.client_id,
          effortNr: props.effortNr,
          catchNr: props.catchNr,
          types: props.types,
        }}
      >
        <Button>Add Catch</Button>|
      </Link>
      <Link
        to={`${process.env.PUBLIC_URL}/vtr-trip-review`}
        state={{
          trip_id: props.trip_id,
          client_id: props.client_id,
        }}
      >
        <Button>Trip Review</Button>
      </Link>
      {props.deleteEffort && (
        <>
          |<Button onClick={props.deleteEffort}>Delete Effort</Button>
        </>
      )}
    </div>
  );
};

export default EffortReviewNav;
